import { useId } from 'react';

const useHiddenUntilHover = () => {
  const id = useId();
  const wrapperSx = {
    backgroundColor: 'red',

    [`& #${CSS.escape(id)}`]: {
      opacity: 0,
    },
    '&:hover, &:focus-within': {
      [`& #${CSS.escape(id)}`]: {
        opacity: 1,
      },
    },
  };

  return {
    wrapperSx,
    hiddenElementId: id,
  };
};

export default useHiddenUntilHover;
